/**
 * ViewAllLink — small "View all X →" button used as a widget footer.
 * Designed to be passed to WidgetCard's `footer` prop so it pins to the
 * bottom of the card outside the scroll area.
 */

import * as React from "react";

export interface ViewAllLinkProps {
  label: string;
  onClick?: () => void;
}

export function ViewAllLink({ label, onClick }: ViewAllLinkProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full flex items-center justify-center gap-1 py-1 text-[11px] font-semibold text-blue-600 hover:text-blue-700 transition-colors"
    >
      {label}
      <span aria-hidden className="text-[12px] leading-none">→</span>
    </button>
  );
}
